module.exports = __webpack_public_path__ + "img/heart-filled.58abee78.svg";